import { fillString } from '@local_modules/generic/string-template.js'
import { setElementHtml } from '../../../../helpers/generic-js/dom.js'
import { applyHtmlRestrictions } from '../../../../helpers/restrictions/apply-html-restrictions.js'
import { checkPageRestriction } from '../../../../helpers/restrictions/check-page-restriction.js'

import htmlTemplateIndex from './index.html'
import { generateRandomString } from '@local_modules/generic/text/generate-random-string/index.js'

import { loadGroupAllContacts } from './load-data.js'
import { showTableGroupAllContacts } from './show-table.js'

/**
 *
 * @returns
 */
export async function showPageGroupAllContacts (params) {
  console.log('showPageGroupAllContacts')

  const { containerElementId, browserAppUser, browserAppAccount } = params

  if (!checkPageRestriction({ browserAppUser, browserAppAccount, allowPublic: true })) return

  // Prepare the html
  let htmlIndex = htmlTemplateIndex
  htmlIndex = applyHtmlRestrictions(htmlIndex, { browserAppAccount, browserAppUser })
  const elementId = 'i' + generateRandomString()
  htmlIndex = fillString(htmlIndex, { elementId })

  // Inject in the page
  setElementHtml(containerElementId, htmlIndex)

  document.title = ['Group Contacts:', browserAppAccount.data.appAccount.name].join(' ')

  // Set full height
  document.getElementById('app-content').classList.add('position-absolute')
  document.getElementById('app-content').classList.add('top-to-bottom')

  const groupContactsResponse = await loadGroupAllContacts(browserAppAccount.data.appAccountId)

  showTableGroupAllContacts(groupContactsResponse, browserAppAccount.data.entities)
}
